module.exports = __webpack_public_path__ + "img/mobile.svg.60deab50.png";